import { useState, useEffect } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { createMarkup } from '../Helpers/FormHelper';
import FadeLoader from "react-spinners/FadeLoader";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

const cssOverride = css`
  display: block;
  margin: 0 auto;
`;

export function PageInfo({ pageId }) {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState();
  const [error, setError] = useState();

  useEffect(() => {
    console.log('component mounted!');
    const populateData = async () => {
      try {
        await axios.get(`/page/${pageId}`)
          .then((response) => {
            if (response.data != null) {
              setData(response.data);
            } else {
              setData({ messageHTML: "" });
            }
            setIsLoading(false);
          });
      } catch (e) {
        setError(e.message);
        setIsLoading(false);
      }
    }

    populateData();
  }, [pageId])

  const styleObj = {
    marginTop: "5px"
  }

  if (isLoading) {
    return (
      <div className="sweet-loading">
        <FadeLoader color="#711C21" loading={isLoading} css={cssOverride} size={150} />
      </div>
    )
  }
  if (error)
    return (<h2><b>Problem loading page data: {error}</b></h2>);
  if (data) {
    return (
      <div className="row">
        <div className="col-sm-12">
          <div className="card main-card">
            <div className="card-body" dangerouslySetInnerHTML={createMarkup(data.messageHTML)} style={styleObj}>
            </div>
          </div>
        </div>
      </div>
    );
  }
  return (<p>No data yet</p>);
}

PageInfo.propTypes = {
  pageId: PropTypes.number.isRequired
}
